var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PluginPublishFlowAppContentStep"},[_c('h6',{staticClass:"mb-4"},[_vm._v("More Information")]),_c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }